<template>
  <div class="col-md-12">
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Subject :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Subject"
            v-validate="'required'"
            v-model="encodingData.Subject"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('Subject') }"
          />
        </div>
        <div v-if="submitted && errors.has('Subject')" class="invalid-feedback">
          {{ errors.first("Subject") }}
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Date Started :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="date"
            name="DateStart"
            v-validate="'required'"
            v-model="encodingData.DateStart"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('DateStart') }"
          />
        </div>
        <div
          v-if="submitted && errors.has('DateStart')"
          class="invalid-feedback"
        >
          {{ errors.first("DateStart") }}
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Date End :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="date"
            name="DateEnd"
            v-validate="'required'"
            v-model="encodingData.DateEnd"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('DateEnd') }"
          />
        </div>
        <div v-if="submitted && errors.has('DateEnd')" class="invalid-feedback">
          {{ errors.first("DateEnd") }}
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Time Start :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="TimeStart"
            v-model="encodingData.TimeStart"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Time End :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="TimeEnd"
            v-model="encodingData.TimeEnd"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Event Type:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name="Type" v-model="encodingData.Type" class="form-control">
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.eventType"
              v-bind:key="option.eventType"
            >
              {{ option.eventType }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Latitude :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="Gpslat"
            v-model="encodingData.Gpslat"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Longitude :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="Gpslon"
            v-model="encodingData.Gpslon"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name v-model="encodingData.Country" class="form-control">
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Region:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name v-model="encodingData.Region" class="form-control">
            <option value>Select Region</option>
            <option
              v-for="option in regions"
              v-bind:value="option.region"
              v-bind:key="option.region"
            >
              {{ option.region }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >State:</label
        >
        <div class="col-md-6 col-sm-6">
          <select name v-model="encodingData.State" class="form-control">
            <option value>Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >City :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="City"
            v-model="encodingData.City"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Wounded :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="number"
            name="Wounded"
            v-model="encodingData.Wounded"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Killed :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="number"
            name="Killed"
            v-model="encodingData.Killed"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Status :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="EvStatus"
            v-model="encodingData.EvStatus"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
      </div>
      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopEV" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>

<script>
import {
  authHeader,
  notifyHelper,
  EncodeURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageEventType,
  getlocalstorageEventRegion,
  setObject2Link,
  checkLinkMode,
  responseCheck,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Subject: "",
        DateStart: "",
        DateEnd: "",
        TimeStart: null,
        TimeEnd: null,
        Type: "",
        Gpslat: null,
        Gpslon: null,
        Country: "",
        Region: "",
        State: "",
        City: "",
        Wounded: 0,
        Killed: 0,
        Comments: "",
        EvStatus: "",
      },
      countries: [],
      provinces: [],
      types: [],
      regions: [],
      submitted: false,
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          instance
            .post(EncodeURL + "newevent", this.encodingData, {
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                loader.hide();
                notifyHelper(
                  "error",
                  "there was an error processing your request please try again later"
                );
              } else {
                notifyHelper("success", "Saved!");
                //this.createControls()
                loader.hide();
                if (checkLinkMode()) {
                  if (confirm("Link this newly created entity?")) {
                    setObject2Link(response.data.id, "EV");
                    this.setLink(response.data.id);
                  }
                }
              }
            })
            .catch(function (error) {
              loader.hide();
              responseCheck(error.response.status);
            });
        }
      });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstorageEventType();
      this.regions = getlocalstorageEventRegion();
    },
    setLink: function (id) {
      setObject2Link(id, "EV");
      this.$bvModal.show("LinkPopEV");
    },
    clearControls() {
      this.encodingData.Subject = "";
      this.encodingData.DateStart = "";
      this.encodingData.DateEnd = "";
      this.encodingData.TimeStart = null;
      this.encodingData.TimeEnd = null;
      this.encodingData.Type = "";
      this.encodingData.Gpslat = null;
      this.encodingData.Gpslon = null;
      this.encodingData.Country = "";
      this.encodingData.Region = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
      this.encodingData.Wounded = "";
      this.encodingData.Killed = "";
      this.encodingData.Comments = "";
      this.encodingData.EvStatus = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>
